import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock, Mail, User } from 'lucide-react';
export function SignupPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Basic validation
    if (!firstName || !lastName || !email || !password) {
      setError('Please fill in all required fields');
      return;
    }
    if (!acceptTerms) {
      setError('You must accept the terms of service and privacy policy');
      return;
    }
    setIsLoading(true);
    setError('');
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Redirect to onboarding instead of dashboard
      navigate('/onboarding');
    }, 1500);
  };
  return <div className="min-h-screen bg-[#376770] flex flex-col items-center justify-center px-4 py-12" data-id="element-1593">
      {/* Logo */}
      <div className="mb-8 text-center" data-id="element-1594">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJkprGARCzfGvbLTaJLb3b/Elze_logo.svg" alt="Elze Logo" className="h-16 w-auto mx-auto filter brightness-0 invert-[1]" data-id="element-1595" />
      </div>
      {/* Form Container */}
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-1596">
        <div className="px-6 py-8" data-id="element-1597">
          <h2 className="text-2xl font-semibold text-[#164149] mb-6 text-center" data-id="element-1598">
            Create your account
          </h2>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded" data-id="element-1599">
              {error}
            </div>}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1600">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1601">
              <div data-id="element-1602">
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1603">
                  First Name
                </label>
                <div className="relative" data-id="element-1604">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1605">
                    <User size={18} className="text-gray-400" data-id="element-1606" />
                  </div>
                  <input id="firstName" type="text" value={firstName} onChange={e => setFirstName(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="John" required data-id="element-1607" />
                </div>
              </div>
              <div data-id="element-1608">
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1609">
                  Last Name
                </label>
                <div className="relative" data-id="element-1610">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1611">
                    <User size={18} className="text-gray-400" data-id="element-1612" />
                  </div>
                  <input id="lastName" type="text" value={lastName} onChange={e => setLastName(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="Doe" required data-id="element-1613" />
                </div>
              </div>
            </div>
            <div data-id="element-1614">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1615">
                Email
              </label>
              <div className="relative" data-id="element-1616">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1617">
                  <Mail size={18} className="text-gray-400" data-id="element-1618" />
                </div>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="name@example.com" required data-id="element-1619" />
              </div>
            </div>
            <div data-id="element-1620">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1621">
                Password
              </label>
              <div className="relative" data-id="element-1622">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1623">
                  <Lock size={18} className="text-gray-400" data-id="element-1624" />
                </div>
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="••••••••" required data-id="element-1625" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-1626">
                  {showPassword ? <EyeOff size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1627" /> : <Eye size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1628" />}
                </button>
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-1629">
                Password must be at least 8 characters
              </p>
            </div>
            <div className="flex items-start" data-id="element-1630">
              <div className="flex items-center h-5" data-id="element-1631">
                <input id="terms" name="terms" type="checkbox" checked={acceptTerms} onChange={e => setAcceptTerms(e.target.checked)} className="h-4 w-4 text-[#376770] focus:ring-[#376770]/20 border-gray-300 rounded" data-id="element-1632" />
              </div>
              <div className="ml-3 text-sm" data-id="element-1633">
                <label htmlFor="terms" className="text-gray-700" data-id="element-1634">
                  I accept the{' '}
                  <Link to="/terms" className="font-medium text-[#376770] hover:text-[#164149]" data-id="element-1635">
                    Terms of Service
                  </Link>{' '}
                  and{' '}
                  <Link to="/privacy" className="font-medium text-[#376770] hover:text-[#164149]" data-id="element-1636">
                    Privacy Policy
                  </Link>
                </label>
              </div>
            </div>
            <div data-id="element-1637">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#376770] hover:bg-[#164149] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#376770] transition-colors" data-id="element-1638">
                {isLoading ? <span className="flex items-center" data-id="element-1639">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1640">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1641"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1642"></path>
                    </svg>
                    Registering...
                  </span> : 'Sign up'}
              </button>
            </div>
          </form>
          <div className="mt-6 text-center" data-id="element-1643">
            <p className="text-sm text-gray-600" data-id="element-1644">
              Already have an account?{' '}
              <Link to="/login" className="font-medium text-[#376770] hover:text-[#164149]" data-id="element-1645">
                Log in
              </Link>
            </p>
          </div>
        </div>
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 text-center" data-id="element-1646">
          <p className="text-xs text-gray-500" data-id="element-1647">
            By signing up, you agree to receive updates from Elze about the
            latest news and features
          </p>
        </div>
      </div>
    </div>;
}